module.exports = __webpack_public_path__ + "static/media/background3.5df7dc76.jpg";